import React from 'react';
import armanLogo from '../assets/arman-logo.png';

const Footer = () => {
  return (
    <footer className="footer" id='Footer'>
      <div className="footer-content">
        <div className="footer-branding">
          <div className="footer-logo-wrapper">
            <img src={armanLogo} alt="ARMAN Software" className="footer-logo-img" />
          </div>
          <div className="footer-text-wrapper">
            <h3 className="footer-title">تیم توسعه نرم افزاری آرمان</h3>
            <p className="footer-subtitle">ARMAN Software Development Team</p>
          </div>
        </div>
        
        <div className="footer-divider"></div>
        
        <div className="footer-links">
          <a href="https://armandev.ir" target="_blank" rel="noopener noreferrer" className="footer-link">
            <i className="fas fa-globe"></i>
            <span>وب‌سایت</span>
          </a>
          <a href="mailto:info.armanteam@gmail.com" className="footer-link">
            <i className="fas fa-envelope"></i>
            <span>تماس با ما</span>
          </a>
          <a href="https://armandev.ir/projects" target="_blank" rel="noopener noreferrer" className="footer-link">
            <i className="fas fa-briefcase"></i>
            <span>نمونه کارها</span>
          </a>
        </div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">
            <i className="fas fa-code"></i>
            طراحی و توسعه توسط تیم آرمان
          </p>
          <p className="footer-year">© {new Date().getFullYear()} تمامی حقوق محفوظ است</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
